<template lang="pug">
BriqMultiselect(
  :label="customField.FieldName"
  :help="customField.Description"
  v-model="innerValue"
  display="Name"
  track-by="Value"
  :options="customField.ValueOptions"
  :hideOptionalMarker="true"
  :error="error"
  :taggable="true"
  :close-on-select="true"
  :multiple="customField.Datatype === 'MultiList'"
  :bindObject="customField.Datatype === 'MultiList'"
  :max="customField.Datatype === 'MultiList' && customField.MaxOccurs > 0 ? customField.MaxOccurs : false"
  :required="!customField.Optional"
  data-test-id="custom-field-dropdown"
)
</template>

<script>
import { validateProps } from '@v/util/propValidators.js'

export default {
  name: 'CustomFieldDropdown',
  props: {
    customField: {
      type: Object,
      validator: validateProps(['FieldCode', 'FieldName', 'Optional']),
    },
    value: [String, Number, Array],
    error: String,
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>
